export default __webpack_public_path__ + "static/media/Eran Spahbed Ajanta.eec94138.jpg";